export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popover-item.vue?vue&type=template&id=5b3d7caa&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/popover/popover-item.vue?vue&type=template&id=5b3d7caa&
// module id = 962
// module chunks = 0